<template>
    <div>
        <span class="field">{{ $t(`feed.fields.${detail.field}`) }}</span>
        <div class="mb-2" v-if="detail.from != null">
            <span class="field">{{ $t('feed.from') }}:</span>
            <span class="feed-comment" v-html="detail.from"></span>
        </div>
        <div class="mb-2">
            <span class="field">{{ $t('feed.to') }}:</span>
            <span class="feed-comment" v-html="detail.to"></span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BaseDescription',
    props: {
        detail: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style scoped>
.feed-comment ::v-deep p {
    margin: 0;
}
</style>
